import { BaseElements, BaseObject, BaseService, BaseInjector } from '../../../js/base';
import PasswordEqualityValidation from './password-equality-validation';
import PasswordFormatValidation from './password-format-validation';
import { querySelector } from '../../../utility/utils/index';

class Texts extends BaseObject { }

class ClassList extends BaseObject { }

class Selectors extends BaseObject {
    form = '.registration-form';
    passwordInput = '[type="password"]';
}

class Elements extends BaseElements<Selectors> {
    form: HTMLFormElement;
    passwordInputs: NodeListOf<HTMLElement>;

    constructor(selectors: Selectors) {
        super(selectors, true);
    }

    initElements() {
        this.form = querySelector(this.selectors.form);
        if (this.form) {
            this.passwordInputs = this.form.querySelectorAll(this.selectors.passwordInput)
        }
    }
}

interface Registration extends BaseService<Selectors, Elements, ClassList, Texts> { }

@BaseInjector(Selectors, Elements, ClassList, Texts)
class Registration {
    passwordFormatValidation: PasswordFormatValidation;
    passwordEqualityValidation: PasswordEqualityValidation;

    invalid = {
        passwords: false,
        passwordFormat: false
    }

    initialize(): void {
        if(!this.elements.form){
            return
        }
        this.initPasswordFormatValidation();
        this.initPasswordEqualityValidation();
        this.addEventListeners();
    }

    initPasswordFormatValidation() {
        this.passwordFormatValidation = new PasswordFormatValidation();
    }

    initPasswordEqualityValidation() {
        this.passwordEqualityValidation = new PasswordEqualityValidation(this.elements.form);
    }

    addEventListeners(): void {
        this.elements.form.addEventListener('submit', this.onSubmit.bind(this));
        this.elements.passwordInputs.forEach( passwordInput => {
            passwordInput.addEventListener('change', this.onChangePassword.bind(this));
        });
    }

    onSubmit(event: Event) {
        event.preventDefault();
        if (this.checkPasswords() && this.checkPasswordFormat()) {
            this.addData('submitBtn', 'submitBtn');
            this.elements.form.submit();
        } else {
            this.elements.form.scrollIntoView();
        }
    }

    onChangePassword() {
        this.checkPasswords();
    }

    checkPasswordFormat() {
        return this.passwordFormatValidation.checkPasswordFormat();
    }

    checkPasswords() {
        return this.passwordEqualityValidation.checkPasswordEquality();
    }

    //TODO: make it shareable - move it to utilities?
    addData(name: string, value = '') {
        let el = document.querySelector('[name="' + name + '"]');
        if (el) {
            value = el.getAttribute('value');
            el.removeAttribute('name');
        }
        let input = document.createElement('input');
        input.setAttribute('name', name);
        input.setAttribute('value', value);
        input.setAttribute('type', 'hidden');
        this.elements.form.appendChild(input);
    }

    //TODO: make it shareable - move it to utilities?
    setTooltip(el, text) {
        el.dataset.toggle = 'tooltip';
        el.setAttribute('title', text);
        $(el).tooltip()
    }
    //TODO: make it shareable - move it to utilities?
    destroyTooltip(el) {
        el.setAttribute('title', '');
        $(el).tooltip('dispose')
    }

}

export default Registration;

export {
    Elements as RegistrationElements,
    Selectors as RegistrationSelectors,
    ClassList as RegistrationClassList,
    Texts as RegistrationTexts
}